import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import { useList } from '@refinedev/core';
import { useMemo } from 'react';

type FactFind = {
  id: string;
  clientId: string;
  fileId?: number;
  fileName?: string;
  createdAt: string;
  isGenerated: true;
};

export const useFactFinds = () => {
  const { clientId } = useCurrentClient();

  const { data, isLoading, isError, error, refetch } = useList<Omit<FactFind, 'isGenerated'>>({
    resource: `clients/${clientId}/fact-finds`,
  });

  const factFinds = useMemo(
    () =>
      data?.data.map(factFind => ({
        ...factFind,
        isGenerated: true,
      })) || [],
    [data],
  );

  return {
    factFinds,
    isLoading,
    isError,
    error,
    refetch,
  };
};
